import { useState, useRef } from 'react';

export default function ProductSection() {
  const products = [
    {
      name: 'デリカスパークリングルシア 白',
      origin: 'スペイン産',
      alcohol: 'アルコール8.5%',
      taste: 'やや甘口',
      led: true,
      image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/4694ddf21f1d3e1831b0cad83747606d.jpeg',
    },
    {
      name: 'アンジュエール 白',
      origin: 'スペイン産',
      alcohol: 'アルコール8.5%',
      taste: 'やや甘口',
      led: true,
      image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/9c7102acd68ccc5d5ffc9044d541b797.jpeg',
    },
    {
      name: 'デリカ スパークリング ルシア ロゼ',
      origin: 'スペイン産',
      alcohol: 'アルコール8.5%',
      taste: 'やや甘口',
      led: true,
      image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/b9bf05b37e15b1b146c9a8dbadbaf616.jpeg',
    },
    {
      name: 'シャンメイ ノンアルコール ロゼ',
      origin: 'フランス産',
      alcohol: '完全アルコールゼロ',
      taste: '100%果汁',
      led: true,
      image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/a3d1eece2af335b6090dcb794462d538.jpeg',
    },
    {
      name: 'シャンメイ ノンアルコール 白',
      origin: 'フランス産',
      alcohol: '完全アルコールゼロ',
      taste: '100%果汁',
      led: true,
      image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/0297f6c459e0c6034f759af7c3482a33.jpeg',
    },
    {
      name: 'フルーツシャンパン ピーチ',
      origin: '',
      alcohol: 'アルコール4%',
      taste: 'ピーチ風味',
      led: true,
      image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/21d0f5afd5c80a4e69247b68fd8d0415.jpeg',
    },
    {
      name: 'フルーツシャンパン グリーンアップル',
      origin: '',
      alcohol: 'アルコール4%',
      taste: 'グリーンアップル風味',
      led: true,
      image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/7fb167eed9b896790baeb29d54222400.jpeg',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef<number | null>(null);

  const prev = () => setCurrentIndex((i) => (i - 1 + products.length) % products.length);
  const next = () => setCurrentIndex((i) => (i + 1) % products.length);

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (diff > 40) next();
    else if (diff < -40) prev();
    touchStartX.current = null;
  };

  const product = products[currentIndex];

  return (
    <section id="products" className="py-16 md:py-24 bg-gradient-to-b from-black to-purple-950/20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 md:mb-6">
            商品ラインナップ
          </h2>
          <p className="text-base md:text-lg text-gray-300 mb-4">豊富なバリエーションからお選びいただけます</p>
          <div className="inline-flex flex-col items-center gap-3 bg-white/5 border border-yellow-400/30 rounded-2xl px-6 md:px-10 py-4 md:py-5">
            <span className="text-yellow-400 text-sm font-bold tracking-widest uppercase">一律価格</span>
            <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-8">
              <div className="text-center">
                <p className="text-white text-base font-semibold">通常ボトル</p>
                <p className="text-yellow-400 text-2xl font-bold">2,750<span className="text-sm font-normal text-gray-300">円（税込）</span></p>
              </div>
              <div className="hidden sm:block w-px h-10 bg-yellow-400/30"></div>
              <div className="text-center">
                <p className="text-white text-base font-semibold">LEDボトル</p>
                <p className="text-yellow-400 text-2xl font-bold">3,080<span className="text-sm font-normal text-gray-300">円（税込）</span></p>
              </div>
            </div>
            <p className="text-gray-400 text-xs">※送料別</p>
          </div>
        </div>

        {/* モバイル: スライダー */}
        <div className="md:hidden mb-8">
          <div
            className="relative"
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <div className="bg-gradient-to-br from-purple-900/30 to-black/50 rounded-3xl overflow-hidden border border-purple-500/20">
              <div className="relative h-80 overflow-hidden bg-gradient-to-b from-purple-900/20 to-black/80">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain object-center"
                />
                {product.led && (
                  <div className="absolute top-4 right-4 bg-yellow-400 text-black text-sm font-bold px-4 py-2 rounded-full shadow-lg">
                    <i className="ri-lightbulb-flash-line mr-1"></i>LED対応
                  </div>
                )}
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-3">{product.name}</h3>
                <div className="space-y-2 text-gray-300">
                  {product.origin && (
                    <div className="flex items-center gap-2">
                      <i className="ri-map-pin-line text-yellow-400"></i>
                      <span className="text-sm">{product.origin}</span>
                    </div>
                  )}
                  <div className="flex items-center gap-2">
                    <i className="ri-drop-line text-yellow-400"></i>
                    <span className="text-sm">{product.alcohol}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-goblet-line text-yellow-400"></i>
                    <span className="text-sm">{product.taste}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* 左右ボタン */}
            <button onClick={prev} className="absolute left-2 top-1/3 -translate-y-1/2 w-10 h-10 bg-black/60 rounded-full flex items-center justify-center text-white border border-purple-500/40">
              <i className="ri-arrow-left-s-line text-2xl"></i>
            </button>
            <button onClick={next} className="absolute right-2 top-1/3 -translate-y-1/2 w-10 h-10 bg-black/60 rounded-full flex items-center justify-center text-white border border-purple-500/40">
              <i className="ri-arrow-right-s-line text-2xl"></i>
            </button>
          </div>

          {/* ドット */}
          <div className="flex justify-center gap-2 mt-4">
            {products.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`w-2 h-2 rounded-full transition-all ${i === currentIndex ? 'bg-yellow-400 w-4' : 'bg-gray-600'}`}
              />
            ))}
          </div>
        </div>

        {/* PC: グリッド */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {products.map((p, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-purple-900/30 to-black/50 rounded-3xl overflow-hidden border border-purple-500/20 hover:border-yellow-400/50 transition-all duration-500 hover:scale-105 cursor-pointer group"
            >
              <div className="relative h-96 overflow-hidden bg-gradient-to-b from-purple-900/20 to-black/80">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-contain object-center group-hover:scale-110 transition-transform duration-700"
                />
                {p.led && (
                  <div className="absolute top-4 right-4 bg-yellow-400 text-black text-sm font-bold px-4 py-2 rounded-full shadow-lg">
                    <i className="ri-lightbulb-flash-line mr-1"></i>LED対応
                  </div>
                )}
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-4 leading-tight">{p.name}</h3>
                <div className="space-y-2 text-gray-300">
                  {p.origin && (
                    <div className="flex items-center gap-2">
                      <i className="ri-map-pin-line text-yellow-400"></i>
                      <span className="text-sm">{p.origin}</span>
                    </div>
                  )}
                  <div className="flex items-center gap-2">
                    <i className="ri-drop-line text-yellow-400"></i>
                    <span className="text-sm">{p.alcohol}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-goblet-line text-yellow-400"></i>
                    <span className="text-sm">{p.taste}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://line.me/R/ti/p/@ula6319m?oat_content=url"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#06C755] hover:bg-[#05b34c] text-white text-base md:text-lg font-bold px-8 md:px-10 py-3 md:py-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-xl md:text-2xl"></i>
            商品について詳しく聞く
          </a>
        </div>
      </div>
    </section>
  );
}
